import { render } from "./Transcription.vue?vue&type=template&id=0fb85b00&ts=true"
import script from "./Transcription.vue?vue&type=script&lang=ts"
export * from "./Transcription.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__